import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { INTL_PICKER_DATE_FORMAT } from 'constants/dateFormats'
import { FlightsFareTypes } from 'constants/flight'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import type { Moment } from 'moment'
import moment from 'moment'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  checkInDate?: Moment
  checkOutDate?: Moment
  fareType?: string
}

function FormattedFlightSearchDate(props: Props) {
  const { checkInDate, checkOutDate, fareType } = props
  const intl = useIntl()
  const dateFormatter = useIntlDateFormatter()

  const isOneWay = fareType === FlightsFareTypes.ONE_WAY

  const formattedCheckInDate = useMemo(() => {
    return checkInDate?.isValid() ? dateFormatter(moment(checkInDate).toDate(), INTL_PICKER_DATE_FORMAT) : undefined
  }, [checkInDate, dateFormatter])

  const formattedCheckOutDate = useMemo(() => {
    return checkOutDate?.isValid() ? dateFormatter(moment(checkOutDate).toDate(), INTL_PICKER_DATE_FORMAT) : undefined
  }, [checkOutDate, dateFormatter])

  const selectDateText = intl.formatMessage({
    id: '1uBg7WuJkh6t4t7RVoK2',
    defaultMessage: 'Select date',
    description: 'Placeholder text for date selection in flight search',
  })

  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <BodyText
      variant="medium"
      weight={formattedCheckInDate ? 'bold' : 'normal'}
      colour={formattedCheckInDate ? 'normal-contrast' : 'light-foreground-alt'}
    >
      {formattedCheckInDate || selectDateText}
    </BodyText>

    {!isOneWay && (<>
      <LineArrowRightIcon />

      <BodyText
        variant="medium"
        weight={formattedCheckOutDate ? 'bold' : 'normal'}
        colour={formattedCheckOutDate ? 'normal-contrast' : 'light-foreground-alt'}
      >
        {formattedCheckOutDate || selectDateText}
      </BodyText>
    </>)}
  </Group>
}

export default FormattedFlightSearchDate
